const Index = () => import('./index.vue');
const FullStock = () => import('./full-stock.vue');
const Branches = () => import('./branches.vue');
const NoInventory = () => import('./no-inventory.vue');
const CategoryStock = () => import('./categories.vue');

export default [
    {
        path: '/check-full-stock',
        component: FullStock
    },
    {
        path: '/check-stock',
        component: Index
    },
    {
        path: '/no-inventory',
        component: NoInventory
    },
    {
        path: '/branches-stock',
        component: Branches
    },
    {
        path: '/stock-by-category',
        component: CategoryStock
    }
];